import storefront from "../../global/storefront";
import unwrapNodes from "../unwrapNodes";
import { swatchDetails } from "../../global/storefront/queries";

const cache = {};

/**
 * Body copy for one swatch product, memoized for the page's lifetime.
 *
 * @param {string} id product gid `gid://shopify/Product/12345`
 * @returns {Promise<Object>}
 */
export default function fetchSwatchDetails(id) {
  if (id in cache) {
    return cache[id];
  }

  cache[id] = storefront
    .request({
      query: swatchDetails,
      variables: { id },
    })
    .then(({ data }) => unwrapNodes(data.product));

  return cache[id];
}
